// extracted by mini-css-extract-plugin
module.exports = {"container":"CMSSearchItem_container__18laS","addBtn":"CMSSearchItem_addBtn__2yhqw"};